<div class="map-container">
  <google-map
    width="100%"
    height="80vh"
    [center]="center"
    [zoom]="zoom"
    [options]="mapOptions"
    (zoomChanged)="onZoomChange()"
  >
  </google-map>
</div>
